import ManagerDiscoveryPlaceCreate from './ManagerDiscoveryPlaceCreate.container';

export default ManagerDiscoveryPlaceCreate;
